import { useState, useMemo } from "react";
import { GALLERY_MEDIA } from "./galleryData";

export default function useGalleryFilter(initial = "all") {
  const [activeFilter, setActiveFilter] = useState(initial);

  const filteredItems = useMemo(() => {
    if (activeFilter === "all") return GALLERY_MEDIA;
    return GALLERY_MEDIA.filter((item) => item.type === activeFilter);
  }, [activeFilter]);

  return { activeFilter, setActiveFilter, filteredItems };
}
